<script lang="ts">
    import {onMount} from "svelte";
    import {ImagePathConfig} from "../../../ImagePathConfig";


    let isReverse = false;

    onMount(() => {
        isReverse = Math.random() < 0.5;
    });

    const imagePathArray = ImagePathConfig.Loading.imageArray;


    $: imagePath = (() => {
        const maxNumber = imagePathArray.length - 1;
        const imageNumber = Math.floor(Math.random() * maxNumber);
        return imagePathArray[imageNumber];
    })();


</script>

<div class="loading-view"
     class:reverse={isReverse}
>
    <img alt="" src={imagePath}/>


</div>
<style lang="scss">
    :global(main.sp) {
        .loading-view {
            > img {
                max-width: 50px;
                max-height: 50px;
            }
        }
    }

    .loading-view {
        height: 100%;

        > img {
            max-width: 100px;
            max-height: 100px;
            height: 100%;
        }

        &.reverse {
            transform: rotateY(180deg);
        }

    }
</style>